import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface PreviewFileProps {
  open: boolean;
  title: string;
  imagePath: string;
  onCloseClicked: () => void;
}

const PreviewFile = ({
  open = false,
  title = "",
  imagePath = "",
  onCloseClicked,
}: PreviewFileProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      maxWidth="xl"
      onClose={() => onCloseClicked()}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <img src={imagePath} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCloseClicked()}>{t("close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewFile;
